var map = {
	"./level-application.svg": "BubL",
	"./level-page.svg": "fx9Y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f4IG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/level\-.*\.svg$
// module id = f4IG
// module chunks = 46